import { JSX, useEffect } from "react";
import { EffectivenessEfficiencyValueEnum } from "@app/projects/servicing-provider/";
import MultiselectDropdown from "@app/shared/checkbox-dropdown/MultiselectDropdown";
import { DropdownItem } from "@app/shared/checkbox-dropdown/types";

interface EffectivenessEfficiencyFilterProps {
  mappedValues: DropdownItem<EffectivenessEfficiencyValueEnum>[];
  selectedValues: DropdownItem<EffectivenessEfficiencyValueEnum>[];
  setSelectedValues: (selectedValues: DropdownItem<EffectivenessEfficiencyValueEnum>[]) => void;
  testId: string;
  title: string;
}

const EffectivenessEfficiencyFilter = (props: EffectivenessEfficiencyFilterProps): JSX.Element => {
  useEffect(() => {
    props.setSelectedValues(props.mappedValues);
  }, []);

  return (
    <MultiselectDropdown
      containerClassName="d-block"
      customSelectInputText={props.selectedValues.length === props.mappedValues.length ? "All" : null}
      items={props.mappedValues}
      onSelectionChanged={(selectedValues: DropdownItem<EffectivenessEfficiencyValueEnum>[]) => { props.setSelectedValues(selectedValues) }}
      label={props.title}
      selectedItems={props.selectedValues}
      testId={props.testId}
    />
  )
}

export default EffectivenessEfficiencyFilter;
